import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { FileHelper } from '../helpers';

@Injectable({ providedIn: 'root', })
export class ExcelService {
    public saveExcel(data: any[][], fileName: string, headers: string[] = null): void {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1');

        if (!headers || headers.length === 0)
            headers = Object.keys(data[0]).filter(k => typeof data[0][k] !== 'function');

        worksheet.addRow(headers);

        data.forEach(row => worksheet.addRow(row));

        console.log("data:", data, "headers:", headers);

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileHelper.DownloadFile(blob, `${fileName}.xlsx`);
        });
    }
}